import React from 'react';
import { Truck, ShieldCheck, MapPin, Star, BadgeIndianRupee, Lock } from 'lucide-react';

/**
 * Slim trust strip pinned to the very top of every page.
 * - Desktop: static, all 5 items visible.
 * - Mobile: same items, horizontally scrolling marquee (CSS-only).
 */
const ITEMS = [
  { icon: Truck,            text: 'FREE Shipping above ₹500' },
  { icon: BadgeIndianRupee, text: 'Easy UPI & Bank payments' },
  { icon: MapPin,           text: 'Pan-India delivery to 25,000+ pincodes' },
  { icon: Star,             text: '5★ rated by 500+ devotees' },
  { icon: ShieldCheck,      text: '100% Authentic, Temple-Grade' },
  { icon: Lock,             text: 'Secure UPI / Bank checkout' },
];

const Item = ({ icon: Icon, text }) => (
  <span className="inline-flex items-center gap-1.5 px-3 whitespace-nowrap">
    <Icon size={13} className="text-yellow-200 shrink-0" />
    <span>{text}</span>
  </span>
);

export const TrustBar = () => (
  <div
    data-testid="trust-bar"
    className="bg-orange-900 text-white text-[11px] sm:text-xs font-medium overflow-hidden"
  >
    {/* Desktop: evenly spaced, single row */}
    <div className="hidden md:flex max-w-7xl mx-auto px-4 py-1.5 justify-center divide-x divide-orange-700">
      {ITEMS.map((it, i) => (
        <Item key={i} {...it} />
      ))}
    </div>

    {/* Mobile: horizontally scrolling marquee */}
    <div className="md:hidden relative whitespace-nowrap py-1.5">
      <div className="inline-flex animate-trust-marquee">
        {ITEMS.concat(ITEMS).map((it, i) => (
          <Item key={i} {...it} />
        ))}
      </div>
    </div>
  </div>
);
